"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIconNumeric = void 0;
var iconSizeNumericOptions = [12, 16, 24, 32, 48, 64];
var iconSizeOptions = ['xsmall', 'small', 'medium', 'large', 'xlarge', 'xxlarge'];
var iconSizesMap = {
  xsmall: 12,
  small: 16,
  medium: 24,
  large: 32,
  xlarge: 48,
  xxlarge: 64
};
var getIconNumeric = exports.getIconNumeric = function getIconNumeric(iconSize) {
  return iconSizesMap[iconSize];
};